import * as forgerock from "@forgerock/javascript-sdk";
import { getLocationParamer } from "@/utils/common";
export const getOuthClient = (isChannelIdHeader = false) => {
    const pathName = window.location?.pathname;
    const pathArray = pathName.split("/");
    const clientId = getLocationParamer("client");
    const appType = getLocationParamer("appType");
    const memberTypeIsApp = window?.MBSSClient;
    const isAndroid =
        navigator.userAgent.match(/android/i) ||
        navigator.userAgent.includes("wv");
    // CPBP_WEB
    if (clientId && clientId === "CPBP_WEB") {
        return "CPBP_WEB";
    }
    if (isChannelIdHeader) {
        switch (pathArray?.[pathArray.length - 1]) {
            case "webcast":
                return "HKJCWEBCAST";
            case "cvrs":
                return "CVRS";
            case "campaign":
                return "JCEW.CAMP";
            case "trc":
                return "RCMW";
            case "cssp":
                return "CSSP";
            case "member":
                if (memberTypeIsApp) {
                    if (isAndroid) return "MBSS.AOS";
                    else return "MBSS.IOS";
                }
                return "MEMW";
            case "mobileApp":
                if (appType) {
                    if (appType === "HKJCTV") {
                        if (isAndroid) return "HKJCTV.AOS";
                        else return "HKJCTV.IOS";
                    } else if (appType === "ThreeInOne") {
                        if (isAndroid) return "Classic-3in1.AOS";
                        else return "Classic-3in1.IOS";
                    } else if (appType === "Racing") {
                        if (isAndroid) return "RACINGTOUCH.AOS";
                        else return "RACINGTOUCH.IOS";
                    }
                }
                return "WCIP";
            default:
                return "WCIP";
        }
    }

    switch (pathArray?.[pathArray.length - 1]) {
        case "webcast":
            return "HKJCWEBCAST";
        case "cvrs":
            return "CVRS";
        case "campaign":
            return "JCEW.CAMP";
        case "trc":
            return "RCMW";
        // case 'cssp':
        //     return 'CSSP';
        default:
            return "WCIP";
    }
};

// const getScope = () => {
//     const pathName = window.location?.pathname
//     const pathArray = pathName.split('/')
//     switch (pathArray?.[pathArray.length - 1]) {
//         case 'webcast':
//            return 'ls_profile';
//         case 'cvrs':
//             return '';
//         case 'campaign':
//             return 'ls_profile';
//         case 'trc':
//             return '';
//         default:
//             return 'ls_profile';
//     }
// }

export const tempConfig = {
    AM_URL: window.globalConfig.VITE_ARKLE_URL,
    REALM_PATH: "customer",
    SCOPE: "ls_profile ls_web.profile ls_marketing.info openid ls_bet.entitlements",
    // openid ls_bet.profile ls_profile
    TIMEOUT: 60000,
    // TREE: 'hkjcHSLogin-Web',
    TREE: "hkjcLSLogin-Web",
    WEB_OAUTH_CLIENT: getOuthClient(),
    NX_NO_CLOUD: "true",
};

const addHeadersMiddleware = (req, action, next) => {
    // switch(action.type) {
    //     case "START_AUTHENTICATE":
    //         req.init.headers.append('Channel-Id', getOuthClient());
    //         break;
    // }
    if (
        [
            "hkjcChangePassword",
            "hkjcForgotPassword",
            "hkjcBetAsso",
            "hkjcTrcAsso",
            "hkjcChangeName",
            "hkjcChangeEmail",
            "hkjcForgotPasswordMagicLink",
            "hkjcWebAccReg",
        ].includes(action?.payload?.tree)
    ) {
        // req.init.headers.append('Channel-Id', getOuthClient());
        req.url.searchParams.set("noSession", true);
    }
    if (req.init.headers && window.globalConfig.useVoiceOtp) {
        if (action?.payload?.tree === "hkjcTrcAsso") {
            req.init.headers.append(
                "API-Version",
                window.globalConfig.arkleApiVersionTrcAsso
            );
        } else {
            req.init.headers.append(
                "API-Version",
                window.globalConfig.arkleApiVersionDefault
            );
        }
    }

    if (req.init.headers) {
        req.init.headers.append("Channel-Id", getOuthClient(true));
        req.init.headers.append(
            "Accept-Language",
            window.location.pathname.split("/")[1]
        );
        if (
            localStorage.getItem("app-trace-id") &&
            window.globalConfig.useSplunkLog
        ) {
            req.init.headers.append("app-trace-name", getOuthClient(true));
            req.init.headers.append(
                "app-trace-id",
                localStorage.getItem("app-trace-id")
            );
        }
    }

    const ArkleStage = window.sessionStorage.getItem("ArkleStage");
    if (ArkleStage) {
        req.url.searchParams.set("stage", ArkleStage);
    }

    next();
};

export const forgerockSet = (config = tempConfig) => {
    forgerock.Config.set({
        clientId: config.WEB_OAUTH_CLIENT,
        middleware: [addHeadersMiddleware],
        redirectUri: `${window.location.origin}/login/callback`,
        scope: config.SCOPE,
        serverConfig: {
            baseUrl: config.AM_URL,
            timeout: parseInt(config.TIMEOUT),
            paths: {
                authenticate: "/am/json/realms/customer/authenticate",
            },
        },
        realmPath: config.REALM_PATH,
        tree: config.TREE,
        type: "code",
    });
};
